module.exports = __webpack_public_path__ + "static/man_smiling-01e0d72dd4b77b4be9436d2344374945.png";